// extracted by mini-css-extract-plugin
export var markdown = "policy-module--markdown--cdadc";